import React, { Component } from 'react';

import LoadingIndication from '../../common/loading-indicator';
import NewsletterBox from '../newsletter-box';
import SiteSubscription from '../../common/site-subscription';
import AnimatedWrapper from '../../core/animated-wrapper';
import shareService from '../../../services/share';
import newslettersService from '../../../services/newsletters';
import SmartAd from '../../ads/smart-ad';
import universalTagNamesService from '../../../services/universal-tag-names';
import VirtualScrollingService from '../../../services/virtual-scrolling';

import './newsletters.css';

class Newsletters extends Component {
  isInPagePull = false;

  constructor(props) {
    super(props);

    const tag = props.match.params.tag;

    this.state = {
      newsletters: [],
      isLoading: true,
      isPartialLoading: true,
      isError: false,
      isThereMorePages: true,
      currentPage: 1, 
      currentNewsNum: 0,          
      tag,
    };

    let twitterTags;
    let publicName;

    if (tag === 'angular') {
      publicName = 'Angular TypeScript',
      twitterTags = ['angular', 'typescript', 'javascript'];
    }
    else {
      twitterTags = universalTagNamesService.getTwitterTagsByTagForNewsletter(tag);
      publicName = universalTagNamesService.getPublicTagName(tag);
    }

    shareService.setupPage({ 
      title: `${publicName} Trends Gallery`,
      isTitlePrefixOn: false,
      tags: twitterTags
    });

    this.debouncedOnScroll = VirtualScrollingService.debounce(this.onScroll, 10);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.debouncedOnScroll);
    this.fetchPage(this.state.currentPage, this.state.tag);
  }

  fetchPage(page, tag) {
    this.isInPagePull = true;

    newslettersService.getNewsletters(this.state.tag, page)
      .then((newslettersResponse) => {
        this.setState((prevState) => {
          const updatedNewsletters = [
            ...prevState.newsletters, 
            ...newslettersResponse.newsletters,
          ];

          const isThereMorePages = updatedNewsletters.length !== newslettersResponse.total;

          return {
            isLoading: false,
            isPartialLoading: false,
            isError: false,
            isThereMorePages,            
            newsletters: updatedNewsletters,
            total: newslettersResponse.total,
            currentPage: page            
          };
        }, () => {
          this.isInPagePull = false;
        });
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          isError: false
        });
      });
  }  
  
  getRestOfNewslettersPartJSX() {
    return this.state.newsletters.slice(1).map((newsletter) => 
      <div key={newsletter._id} className='little-grow-animation'>
        <NewsletterBox tag={ this.state.tag } {...newsletter} />
      </div>
    );
  }

  onScroll = () => {
    if (this.state.isPartialLoading || 
      !this.newslettersRef || 
      this.isInPagePull || 
      !this.state.isThereMorePages) {
        return;
      }

    const isFetchNeeded = VirtualScrollingService.isFetchNeeded(this.newslettersRef);
    if (!isFetchNeeded) return;

    this.setState({
      isPartialLoading: true
    });

    this.fetchPage(this.state.currentPage + 1, this.state.tag);
  }

  setNewslettersContainerRef = (ref) => {
    this.newslettersRef = ref;
  }

  getPartialLoadingJSX() {
    if (this.state.isPartialLoading) {
      return (
        <div className='partial-loading-container'>
          <LoadingIndication />
        </div>
      );
    }

    return '';
  }

  render() {
    let extraJSX;

    if (this.state.isLoading) {
      extraJSX = (
        <LoadingIndication />
      );
    }
    else {
      if (this.state.newsletters.length === 0) {
        extraJSX = (
          <div>
            <p>There are no newsletters</p>
            <SiteSubscription source='Newsletters' mailingListKey={ this.state.tag } />          
          </div>
        );
      }
      else {
        const { total } = this.state;

        extraJSX = (
          <div>
            <p className='shown-newsletters-count'>
              { total } newsletter{ total > 1 ? 's are' : ' is' } shown
            </p>

            <div className='newsletters' ref={this.setNewslettersContainerRef}>
              <div className='latest-newsletter little-grow-animation'>
                <NewsletterBox tag={ this.state.tag } {...this.state.newsletters[0]} buffText='Latest Newsletter' />
              </div>

              <SiteSubscription source='Newsletters' mailingListKey={ this.state.tag } />

              <SmartAd />

              <div className='rest-of-newsletters'>
                {this.getRestOfNewslettersPartJSX()}
              </div>
            </div>

            { this.getPartialLoadingJSX() }
          </div>
        );
      }
    }

    return (
      <section className='regular-page newsletters-container'>
        <h3 className='page-title'>NEWSLETTERS</h3>
        <hr className='title-separator' />

        {extraJSX}
      </section>
    );
  }
}

const AnimatedNewsletters = AnimatedWrapper(Newsletters);
export default AnimatedNewsletters;